import { createWorkflow } from './create'
import { readWorkflow, readWorkflows } from './read'
import { rewindWorkflow } from './rewind'

export const workflows = {
  create: createWorkflow,
  readCollection: readWorkflows,
  readSingle: readWorkflow,
  rewind: rewindWorkflow,
}

export * from './queryHelpers'
export * from './readEntityWorkflows'
export type * from './types'
export { replaceEntityWorkflows } from './cacheTransformFns/replaceEntityWorkflows'
export {
  invalidateEntityWorkflows,
  refreshEntityWorkflows,
} from './refreshEntityWorkflows'
